import type { Player } from "./Player.type"
import type { PlayerColor } from "./PlayerColor.type"

export type ColorNamePair = {
  color1: PlayerColor
  color2: PlayerColor
  dname: string
}

export function makeColorNamePair(color1: PlayerColor, color2: PlayerColor, dname: string): ColorNamePair {
  return { color1, color2, dname }
}

export function makeColorNamePairFromPlayer(player: Player, dname: string = 'Custom'): ColorNamePair {
  const { color1, color2 } = player
  // dname ||= player.dname!
  return { color1, color2, dname }
}

// these default names are well suited for map-making
export const colorNamesPool: Readonly<Array<ColorNamePair>> = [
  makeColorNamePair(0x48b848, 0x78e078, 'Green'),
  makeColorNamePair(0x007BFF, 0x66BFFF, 'Blue'),
  makeColorNamePair(0xff0000, 0xff0000, 'Red'),

  makeColorNamePair(0xff8800, 0xff8800, 'Orange'),
  makeColorNamePair(0x8800ff, 0x8800ff, 'Purple'),

  makeColorNamePair(0xff00ff, 0xff00ff, 'Pink'),
  makeColorNamePair(0x00ffff, 0x00ffff, 'Cyan'),
  makeColorNamePair(0xffff00, 0xffff00, 'Yellow'),
]
